var App = {
    $body:$("body"),

    init: function init() {
        this.isRendered = false;
        this.isClickable = false;
        this.isFirstUpdate = true;
        this.isInitial = true;
        this.hoverTrendLink = false;
        this.$Body = $("body");
        this.$App = $("#App[data-app='first']");
        this.$AppSecond = $("#App[data-app='second']");
        this.$AppMask = $("#AppMask");
        this.$Sidebar = $("#App[data-app='first'] #Sidebar");
        this.$SidebarSecond = $("#App[data-app='second'] #Sidebar");
        this.$SidebarLogo = $("#App[data-app='first'] #SidebarLogo");
        this.$SidebarLogoSecond = $("#App[data-app='second'] #SidebarLogo");
        //this.$Legend = $("#Legend");
        this.$News = $("#App[data-app='first'] #News");
        this.$NewsSecond = $("#App[data-app='second'] #News");
        this.$News2 = $("#App[data-app='first'] #News2");
        this.$News2Second = $("#App[data-app='second'] #News2");
        this.$ZoomBlock = $("#App[data-app='first'] #ZoomBlock");
        this.$ZoomBlockSecond = $("#App[data-app='second'] #ZoomBlock");
        this.currentPage = "disc";
        this.selectedTrend = "";
        this.dataApp = "first";

        this.$Debug = $("#Debug");

        //FastClick.attach(document.body);

        var Utils = require("utils");
        this.utils = new Utils();

        var DiscView = require("views/discView");
        this.discView = new DiscView({
            dataApp: "first"
        });

        this.discViewSecond = new DiscView({
            dataApp: "second"
        });

        var TrendDiscView = require("views/trendDiscView");
        this.trendDiscView = new TrendDiscView({
            dataApp: "first"
        });

        this.trendDiscViewSecond = new TrendDiscView({
            dataApp: "second"
        });

        var Router = require("router");
        this.router = new Router();

        Backbone.history.start();
    },

    updateFromRouter:function(){
        var self = this;
        if(!this.isRendered){
            this.utils.gatherData(function(){
                self.render();
            });
        }else{
            if(this.selectedTrend == ""){
                App.trendDiscView.rollbackAnimation();
                App.trendDiscViewSecond.rollbackAnimation();
            }
            else{
                $(".trend_circle").removeClass("trendhovered")
                                .removeClass("trendhoveredout");
                $("#TrendDisc").empty();
                App.discView.leaveTrend();
                App.discViewSecond.leaveTrend();
                this.selectTrend(this.selectedTrend, true);
            }
        }
    },

    render:function(){
        var self = this;

        this.$App.attr("data-touch", App.utils.isTouchDevice());
        this.$AppSecond.attr("data-touch", App.utils.isTouchDevice());

        this.isRendered = true;
        this.updateAppWidth();

        $(".modal_content").html(App.utils.methodoText);
        this.discView.render();
        this.discViewSecond.render();
        
        this.trendDiscView.render();
        this.trendDiscViewSecond.render();

        this.bindEvents();
        this.update();

        setTimeout(function(){
            self.$AppMask.addClass("notdisplayed");
            self.isInitial = false;
        }, 1300);

        if(this.selectedTrend !== ""){
            this.$App.removeClass("loading");
            this.$AppSecond.removeClass("loading");
            this.selectTrend(this.selectedTrend, false);
        }else{
            this.introAnimate();
        }
    },

    introAnimate:function(){
        var self = this;

        this.isClickable = false;

        self.discView.$DiscInner.addClass("notdisplayed");
        self.discViewSecond.$DiscInner.addClass("notdisplayed");

        $(".discoverlay").addClass("notdisplayed");

        self.discView.$DiscTrends.find(".trend_circle[data-featured='1']").addClass("notdisplayedfeatured");
        self.discViewSecond.$DiscTrends.find(".trend_circle[data-featured='1']").addClass("notdisplayedfeatured");

        this.$Sidebar.addClass("notdisplayed");
        this.$SidebarSecond.addClass("notdisplayed");

        $(".app_extbt").addClass("notdisplayed");

        this.$News.addClass("notdisplayed");
        this.$News2.addClass("notdisplayed");
        this.$NewsSecond.addClass("notdisplayed");
        this.$News2Second.addClass("notdisplayed");

        this.$ZoomBlock.addClass("notdisplayed");
        this.$ZoomBlockSecond.addClass("notdisplayed");

        this.discView.$DiscTrends.find(".trend_circle").addClass("faraway")
                                                        .addClass("introanimed");

        this.discViewSecond.$DiscTrends.find(".trend_circle").addClass("faraway")
                                                        .addClass("introanimed");

        this.utils.computeOrderedIntroTrends();

        setTimeout(function(){
            self.$App.removeClass("loading");
            self.$AppSecond.removeClass("loading");
        }, 700);

        setTimeout(function(){
            self.discView.$DiscInner.removeClass("notdisplayed");
            self.discViewSecond.$DiscInner.removeClass("notdisplayed");
        }, 1000);

        /*setTimeout(function(){
            self.discView.$DiscOverlay.removeClass("notdisplayed");
        }, 1500)*/

        setTimeout(function(){
            self.discView.$Disc.find(".axis_label[data-labelpos='3']").removeClass("notdisplayed");
            self.discViewSecond.$Disc.find(".axis_label[data-labelpos='3']").removeClass("notdisplayed");
        }, 2000);

        setTimeout(function(){
            self.discView.$Disc.find(".axis_label[data-labelpos='2']").removeClass("notdisplayed");
            self.discViewSecond.$Disc.find(".axis_label[data-labelpos='2']").removeClass("notdisplayed");
        }, 2500);

        setTimeout(function(){
            self.discView.$Disc.find(".axis_label[data-labelpos='1']").removeClass("notdisplayed");
            self.discViewSecond.$Disc.find(".axis_label[data-labelpos='1']").removeClass("notdisplayed");
        }, 3000);

        setTimeout(function(){
            self.discView.$Disc.find(".overlay_now").removeClass("notdisplayed");
            self.discViewSecond.$Disc.find(".overlay_now").removeClass("notdisplayed");
        }, 3500);

        var afterTimeoutTrends = 3500 + ((self.utils.orderedIntroTrends.length)*50);
        this.shuffledTrends = _.shuffle(self.utils.orderedIntroTrends);

        var afterTimeoutTrends = 3500 + ((self.utils.orderedIntroTrendsSecond.length)*50);
        this.shuffledTrendsSecond = _.shuffle(self.utils.orderedIntroTrendsSecond);
        setTimeout(function(){
            _.each(self.shuffledTrends, function(trend, inc){
                var $circle = self.discView.$DiscTrends.find(".trend_circle[data-id='"+trend.id+"']");
                setTimeout(function(){
                    $circle.removeClass("faraway");
                }, inc*50);
                setTimeout(function(){
                    $circle.removeClass("introanimed");
                }, (inc*50) + 600);
            });

            _.each(self.shuffledTrendsSecond, function(trend, inc){
                var $circle = self.discViewSecond.$DiscTrends.find(".trend_circle[data-id='"+trend.id+"']");
                setTimeout(function(){
                    $circle.removeClass("faraway");
                }, inc*50);
                setTimeout(function(){
                    $circle.removeClass("introanimed");
                }, (inc*50) + 600);
            });
        }, 3500);

        /*setTimeout(function(){
            self.discView.$Disc.addClass("interpolating");
            setTimeout(function(){
                self.discView.$Disc.addClass("introtranslated");
                self.discView.zoom = 2;
            }, 500);
        }, afterTimeoutTrends + 1000);*/

        setTimeout(function(){
            self.$Sidebar.removeClass("notdisplayed");
            self.$SidebarSecond.removeClass("notdisplayed");
            //self.$Legend.removeClass("notdisplayed");
            self.$ZoomBlock.removeClass("notdisplayed");
            self.$ZoomBlockSecond.removeClass("notdisplayed");

            self.$News.removeClass("notdisplayed");
            self.$News2.removeClass("notdisplayed");
            self.$NewsSecond.removeClass("notdisplayed");
            self.$News2Second.removeClass("notdisplayed");

            $(".app_extbt").removeClass("notdisplayed");

            self.isClickable = true;
        }, afterTimeoutTrends + 1000)
        

        /*setTimeout(function(){
            _.each(self.discView.$DiscTrends.find(".trend_circle[data-featured='1']"), function(circle, inc){
                setTimeout(function(){
                    $(circle).removeClass("notdisplayedfeatured");
                }(inc*500));
            });

            setTimeout(function(){
                
                self.discView.$Disc.removeClass("interpolating");
            }, 0);

            
        }, afterTimeoutTrends+00);*/
    },

    update:function(){
        var self = this;

        console.log("update", this.dataApp);

        App.utils.saveAnalytics(this.dataApp);

        this.discView.update();
        this.discViewSecond.update();

        if(this.dataApp == "first"){
            this.$AppSecond.addClass("disabled");
            this.$App.removeClass("disabled");
        } else {
            this.$App.addClass("disabled");
            this.$AppSecond.removeClass("disabled");
        }

        if(this.isFirstUpdate) this.isFirstUpdate = false;
        else this.router.updateRoute();
    },

    selectTrend:function(trendID, fromTrend){
        this.selectedTrend = trendID;

        if(this.dataApp == "first"){
            this.currentPage = "trend";
            this.trendDiscView.update(trendID, fromTrend);
        } else {
            this.currentPage = "trend2";
            this.trendDiscViewSecond.update(trendID, fromTrend);
        }
        
        this.router.updateRoute();
    },

    bindEvents:function(){
        var self = this;

        /*window.onresize = function(event) {
            if(!self.isInitial){
                window.location.reload(true);
                setTimeout(function(){
                  window.location.reload();
                });
            }
        };*/

        $("#App[data-app='first'] #SidebarLogo").on("click", function(){
            if(self.currentPage == "trend" && App.isClickable){
                self.trendDiscView.rollbackAnimation();
            }
        });

        $("#App[data-app='second'] #SidebarLogo").on("click", function(){
            if(self.currentPage == "trend" && App.isClickable){
                self.trendDiscViewSecond.rollbackAnimation();
            }
        });

        /*
        $(".btabout").on("click", function(){
            self.displayAboutModal();
            return false;
        });
        */

        $("#Cache, .modal_closebt").on("click", function(){
            self.closeModal();
        });

        $("#App[data-app='first'] .sidebar_bt").on("click", function (){
            var elHeight = (window.innerHeight - 300)
            if(elHeight > 366) elHeight = 366;
            $("#App[data-app='first'] .sidebar_text").css("height", elHeight + "px")
            self.$SidebarLogo.addClass("textdisplayed");
            self.$News2.addClass("shrinked");
            self.$News.addClass("shrinked");
        })

        $("#App[data-app='second'] .sidebar_bt").on("click", function (){
            var elHeight = (window.innerHeight - 300)
            if(elHeight > 366) elHeight = 366;
            $("#App[data-app='first'] .sidebar_text").css("height", elHeight + "px")
            self.$SidebarLogoSecond.addClass("textdisplayed");
            self.$News2Second.addClass("shrinked");
            self.$NewsSecond.addClass("shrinked");
        })

        $("#App[data-app='first'] .sidebar_btclose").on("click", function (){
            self.$SidebarLogo.removeClass("textdisplayed");
        })

        $("#App[data-app='second'] .sidebar_btclose").on("click", function (){
            self.$SidebarLogoSecond.removeClass("textdisplayed");
        })

        $(".app_extbt").on("click", function (){
            self.switchRadar();
        })
    },

    switchRadar: function (){
        console.log("switchRadar");
        if(this.dataApp == "first"){
            this.animateToRadarSecond();
        } else {
            this.animateToRadarFirst();
        }
    },

    animateToRadarSecond: function (){
        var self = this;
        this.$Sidebar.addClass("notdisplayed");
        this.$SidebarSecond.addClass("notdisplayed");
        $(".app_extbt").addClass("notdisplayed");

        setTimeout(function (){
            self.discView.$Disc.find("#DiscTrendsWrapper").addClass("opacified");
        }, 600);

        setTimeout(function (){
            self.discView.$Disc.addClass("gridnotext");
            self.discViewSecond.$Disc.addClass("gridnotext");
            self.discView.$Disc.addClass("scaleDown");
            self.discViewSecond.$Disc.addClass("scaleUp");
            self.discViewSecond.$Disc.find("#DiscTrendsWrapper").addClass("opacified");
        }, 1200);

        setTimeout(function (){
            self.dataApp = "second";
            self.currentPage = "disc2";
            self.discViewSecond.$Disc.removeClass("scaleUp");
            self.update();
        }, 1800)

        setTimeout(function (){
            self.$Sidebar.removeClass("notdisplayed");
            self.$SidebarSecond.removeClass("notdisplayed");
        }, 2400)

        setTimeout(function (){
            self.discView.$Disc.removeClass("gridnotext");
            self.discViewSecond.$Disc.removeClass("gridnotext");
            self.discView.$Disc.find("#DiscTrendsWrapper").removeClass("opacified");
            self.discView.$Disc.removeClass("scaleDown");
            self.discViewSecond.$Disc.find("#DiscTrendsWrapper").removeClass("opacified");
            $(".app_extbt").removeClass("notdisplayed");
        }, 2700)

        /*
        this.dataApp = "second";
        this.currentPage = "disc2";
        */
    },

    animateToRadarFirst: function (){
        var self = this;
        this.$Sidebar.addClass("notdisplayed");
        this.$SidebarSecond.addClass("notdisplayed");
        $(".app_extbt").addClass("notdisplayed");

        setTimeout(function (){
            self.discViewSecond.$Disc.find("#DiscTrendsWrapper").addClass("opacified");
        }, 600);

        setTimeout(function (){
            self.discView.$Disc.addClass("gridnotext");
            self.discViewSecond.$Disc.addClass("gridnotext");
            self.discViewSecond.$Disc.addClass("scaleUp");
            self.discView.$Disc.addClass("scaleDown");
            self.discView.$Disc.find("#DiscTrendsWrapper").addClass("opacified");
        }, 1200);

        setTimeout(function (){
            self.dataApp = "first";
            self.currentPage = "disc";
            self.discView.$Disc.removeClass("scaleDown");
            self.update();
        }, 1800)

        setTimeout(function (){
            self.$Sidebar.removeClass("notdisplayed");
            self.$SidebarSecond.removeClass("notdisplayed");
        }, 2400)

        setTimeout(function (){
            self.discView.$Disc.removeClass("gridnotext");
            self.discViewSecond.$Disc.removeClass("gridnotext");
            self.discViewSecond.$Disc.find("#DiscTrendsWrapper").removeClass("opacified");
            self.discViewSecond.$Disc.removeClass("scaleUp");
            self.discView.$Disc.find("#DiscTrendsWrapper").removeClass("opacified");
            $(".app_extbt").removeClass("notdisplayed");
        }, 2700)
    },

    updateAppWidth:function(){
        var self = this;
        this.appWidth = $(window).width();
        this.appHeight = $(window).height();
    },

    displayAboutModal:function(){
        $("#Cache").addClass("displayed");
        $("#AboutModal").addClass("displayed");
    },

    closeModal:function(){
        $("#Cache").removeClass("displayed");
        $("#AboutModal").removeClass("displayed");
    }

};

module.exports = App;
window.App = App;